import React, { useEffect, useRef } from "react";
import SimpleCard from "../../biblio/Cards/SimpleCard";
import ellipse from "../../assets/icons/Ellipse.svg";
import arrowLeft from "../../assets/icons/leftArrow.svg";
import arrowRight from "../../assets/icons/rightArrow.svg";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { getGeneralProjects } from "../../apis/actions/projects.actions";
import Slider from "react-slick";
import line from "../../assets/icons/line-arrow.svg";
import { carousselSettings } from "../utils/utils";

const ProjectsSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const projects = useSelector((state: RootState) => state?.projects?.projects);
  let sliderRef = useRef<Slider | null>(null);
  const next = () => {
    sliderRef?.current?.slickNext();
  };
  const previous = () => {
    sliderRef?.current?.slickPrev();
  };

  useEffect(() => {
    dispatch(getGeneralProjects());
  }, [dispatch]);

  return (
    <section className="takaful--project-section">
      <div className="takaful--project-title">
        <span>{t("projects.span")}</span>
        <p>{t("projects.p")}</p>
      </div>
      <div className="slider-container">
        <Slider {...carousselSettings(4)} ref={sliderRef}>
          {projects.map((project: any) => (
            <div style={{ textAlign: "center" }}>
              <div className="takaful--card-container">
                <SimpleCard
                  projectId={project.id}
                  urlImage={
                    project?.footer_image_ids && project?.footer_image_ids[0]
                      ? project?.footer_image_ids[0]
                      : null
                  }
                  title={project?.project_name}
                />
                <img src={ellipse} alt="" />
              </div>
            </div>
          ))}
        </Slider>
        <div style={{ display: "flex", gap: "1vw", marginLeft: "2vh" }}>
          <div className="takaful--projects-arrow-left" onClick={previous}>
            <img src={arrowLeft} alt="arrow-left" />
          </div>
          <img
            className="takaful--projects-line-middle"
            src={line}
            alt="line"
          />

          <div className="takaful--projects-arrow-right" onClick={next}>
            <img src={arrowRight} alt="arrow-right" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
